import { render, staticRenderFns } from "./OrbitControls.vue?vue&type=template&id=108befca&"
import script from "./OrbitControls.vue?vue&type=script&lang=js&"
export * from "./OrbitControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports